import React, {Component} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'
import swal from 'sweetalert'
import apis from '../../helper/api'
import BootstrapTable from 'react-bootstrap-table-next'
import {Form, FormGroup} from '../../component/form/form'
import ModalRealize from '../../component/form/dialog_realize'

let denom_default = "../../swipe/assets/app/media/img/products/denom-default.jpg"

class ModalListCommisionBonus extends Component {

    constructor(props) {
        super(props)
        util.log("aaa ",props.data)
        this.now = moment().toDate()
        this.state = {
            flag_processing: false,
            data_report: [],
            data_report_bonus: [],
            show_realize: false,
            realize_index: 0,
            realize_report_month: '',
            realize_report_year: ''
        }
        this.submit_realize = this.submit_realize.bind(this)
    }

    componentDidMount() {
        let self = this
        let bonus_url = ""
        let commision_url = ""
        if (this.props.data.agent_id.length !== 0) {
            if (this.props.profile.masterid === this.props.data.master_id) {
                commision_url = apis.monthly_report_agent_me_commision + this.props.data.agent_id + "/report/commission/monthly/" + this.now.getFullYear() 
                bonus_url = apis.monthly_report_agent_me_bonus + this.props.data.agent_id + "/report/bonus/monthly/" + this.now.getFullYear() 
            } else {
                commision_url = apis.monthly_report_agent_downline_commision + this.props.data.master_id + "/agent/detail/" + this.props.data.agent_id + "/report/commission/monthly/" + this.now.getFullYear() 
                bonus_url = apis.monthly_report_agent_downline_bonus + this.props.data.master_id + "/agent/detail/" + this.props.data.agent_id + "/report/bonus/monthly/" + this.now.getFullYear()
            }
        } else {
            commision_url = apis.monthly_report_downline_commision + this.props.data.master_id + "/report/commission/monthly/" + this.now.getFullYear() 
            bonus_url = apis.monthly_report_downline_bonus + this.props.data.master_id + "/report/bonus/monthly/" + this.now.getFullYear() 
        }
        this.get_report_commision(commision_url)
        this.get_report_bonus(bonus_url)
        this.setState({report_year: this.now.getFullYear()})
    }

    on_submit_summary(e) {
        let bonus_url = ""
        let commision_url = ""
        if (this.props.data.agent_id.length !== 0) {
            if (this.props.profile.masterid === this.props.data.master_id) {
                commision_url = apis.monthly_report_agent_me_commision + this.props.data.agent_id + "/report/commission/monthly/" + this.state.year_sel 
                bonus_url = apis.monthly_report_agent_me_bonus + this.props.data.agent_id + "/report/bonus/monthly/" + this.state.year_sel 
            } else {
                commision_url = apis.monthly_report_agent_downline_commision + this.props.data.master_id + "/agent/detail/" + this.props.data.agent_id + "/report/commission/monthly/" + this.state.year_sel 
                bonus_url = apis.monthly_report_agent_downline_bonus + this.props.data.master_id + "/agent/detail/" + this.props.data.agent_id + "/report/bonus/monthly/" + this.state.year_sel
            }
        } else {
            commision_url = apis.monthly_report_downline_commision + this.props.data.master_id + "/report/commission/monthly/" + this.state.year_sel 
            bonus_url = apis.monthly_report_downline_bonus + this.props.data.master_id + "/report/bonus/monthly/" + this.state.year_sel
        }
        this.get_report_commision(commision_url)
        this.get_report_bonus(bonus_url)
        this.setState({report_year: this.state.year_sel})
    }

    get_report_commision(url) {
    	if (this.props.data.master_id) {
    		let body = {
                "session_id" : this.props.session
            }
        let self = this
        self.setState({flag_processing:true, data_report:[]})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_report_commision", err)
                } else {
                    util.log("get_report_commision", res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                        	if (payload.results) {
                                let items = []
                                payload.results.list.map(function(item, i) {
                                    let it = {
                                        "id" : item.id,
                                        "report_month" : item.report_month,
                                        "total_trx_price" : "Rp. " + util.rupiah_format(item.total_trx_price),
                                        "total_commission_received" : "Rp. " + util.rupiah_format(item.total_commission_received),
                                        "total_trx_event" : item.total_trx_event,
                                        "status" : item.status
                                    }
                                    items.push(it)
                                })
                                self.setState({data_report: items})
                            }
                        }
                    }
                }
                self.setState({flag_processing:false})
            })
    	}
    }

    get_report_bonus(url) {
        if (this.props.data.master_id) {
            let body = {
            "session_id" : this.props.session
        }
        let self = this
        self.setState({data_report_bonus:[]})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_report_commision", err)
                } else {
                    util.log("get_report_commision", res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                            if (payload.results) {
                                let items = []
                                payload.results.list.map(function(item, i) {
                                    let it = {
                                        "id" : item.id,
                                        "report_month" : item.report_month,
                                        "total_trx_price" : "Rp. " + util.rupiah_format(item.total_trx_price),
                                        "total_trx_event" : item.total_trx_event,
                                        "total_bonus_received" : "Rp. " + util.rupiah_format(item.total_bonus_received),
                                        "status" : item.status
                                    }
                                    items.push(it)
                                })
                                self.setState({data_report_bonus: items})
                            }
                        }
                    }
                }
            })
        }
    }

    on_select_change(e) {
        this.setState({[e.currentTarget.id] : e.currentTarget.value})
    }

    submit_realize(type, i, report_year, report_month, status_new, remark_input, pajak_satuan, pajak_value) {
        util.log("submit-realize", type, i, report_year, report_month, status_new, remark_input, pajak_satuan, pajak_value)
        if (type.length !== 0) {
            if (type === 'komisi') {
                this.submit_realize_commision(i, report_year, report_month, status_new, remark_input, pajak_satuan, pajak_value)
            } else if (type === 'bonus') {
                this.submit_realize_bonus(i, report_year, report_month, status_new, remark_input, pajak_satuan, pajak_value)
            }
        }
    }

    submit_realize_commision(i, report_year, report_month, status_new, remark_input, pajak_satuan, pajak_value) {
        if (this.state.flag_processing) return
        let self = this
        let data_commision = self.state.data_report
        let obj = data_commision[i]
        let old_status = obj.status
        let body = {
            "session_id" : this.props.session,
            "year" : report_year,
            "month" : report_month,
            "status_new" : status_new,
            "status_info" : remark_input
        }
        if (pajak_satuan.length !== 0 && pajak_value.length !== 0) {
            body.deduction = {name: 'Pajak', type: pajak_satuan, value: pajak_value}
        }
        obj.status = status_new
        obj.realize_progress = true
        self.setState({flag_processing: true, data_report: data_commision})
        let url = ""
        if (this.props.data.agent_id.length !== 0) {
            if (this.props.profile.masterid === this.props.data.master_id) {
                url = apis.agent_commision_realize.replace('{agent_id}', self.props.data.agent_id)
            } else {
                url = apis.agent_of_downline_commision_realize.replace('{agent_id}', self.props.data.agent_id).replace('{master_id}', self.props.data.master_id)
            }
        } else if (this.props.data.master_id.length !== 0) {
            url = apis.master_commision_realize.replace('{master_id}', self.props.data.master_id)
        }
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let error = false
                if (err || !res.ok) {
                    util.log("agent_realize_commision", err)
                    error = true
                } else {
                    util.log("agent_realize_commision", res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                            // no-op
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                            error = true
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                        error = true
                    }
                }
                obj.realize_progress = false
                if (error) {
                    obj.status = old_status
                }
                self.setState({data_report: data_commision, flag_processing: false})
            })
    }

    submit_realize_bonus(i, report_year, report_month, status_new, remark_input, pajak_satuan, pajak_value) {
        if (this.state.flag_processing) return
        let self = this
        let data_bonus = self.state.data_report_bonus
        let obj = data_bonus[i]
        let old_status = obj.status
        let body = {
            "session_id" : this.props.session,
            "year" : report_year,
            "month" : report_month,
            "status_new" : status_new,
            "status_info" : remark_input
        }
        if (pajak_satuan.length !== 0 && pajak_value.length !== 0) {
            body.deduction = {name: 'Pajak', type: pajak_satuan, value: pajak_value}
        }
        self.setState({flag_processing: true})
        let url = ""
        if (this.props.data.agent_id.length !== 0) {
            if (this.props.profile.masterid === this.props.data.master_id) {
                url = apis.agent_bonus_realize.replace('{agent_id}', self.props.data.agent_id)
            } else {
                url = apis.agent_of_downline_bonus_realize.replace('{agent_id}', self.props.data.agent_id).replace('{master_id}', self.props.data.master_id)
            }
        } else if (this.props.data.master_id.length !== 0) {
            url = apis.master_bonus_realize.replace('{master_id}', self.props.data.master_id)
        }
        obj.status = status_new
        obj.realize_progress = true
        self.setState({data_report_bonus: data_bonus})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                let error = false
                if (err || !res.ok) {
                    util.log("agent_realize_bonus", err)
                    swal("Ups!", err, "warning")
                    error = true
                } else {
                    util.log("agent_realize_bonus", res);
                    if (res.statusCode === 200) {
                        let payload = res.body
                        if (payload.status === "OK") {
                           // no-op
                        } else {
                            swal("Ups!", payload.error.message, "warning")
                            error = true
                        }
                    } else {
                        swal("Error!", res.statusCode, "warning")
                        error = true
                    }
                }
                obj.realize_progress = false
                if (error) {
                    obj.status = old_status
                }
                self.setState({data_report_bonus: data_bonus, flag_processing: false})
            })
    }

    on_select_change_realize_bonus(e, i) {
        util.log(e, i)
        let self = this
        let data_bonus = self.state.data_report_bonus
        let obj = data_bonus[i]
        let old_status = obj.status
        let new_status = e.currentTarget.value
        
        this.setState({show_realize: true, realize_new_status: new_status, realize_report_year: self.state.report_year, realize_report_month: obj.report_month, realize_type: 'bonus', realize_index: i})
    }

    on_select_change_realize_commision(e, i) {
        util.log(e, i)
        let self = this
        let data_commision = self.state.data_report
        let obj = data_commision[i]
        let old_status = obj.status
        let new_status = e.currentTarget.value
        
        this.setState({show_realize: true, realize_new_status: new_status, realize_report_year: self.state.report_year, realize_report_month: obj.report_month, realize_type: 'komisi', realize_index: i})
    }

    render() {
        let self = this
    	let data = this.props.data

        const RowNumber = (cell, row, i) =>
            <div>{i + 1}</div>
        
        const BulanColumn = (cell, row) =>
            <div>
                {util.get_month_name(row.report_month)}
            </div>

        const StatusColumn = (cell, row, i) =>
            <div>
                <div>{row.status === 'REPORTED' ? <select className="m-input" id={"commision_status_sel_" + i} value={row.status} onChange={(e) => this.on_select_change_realize_commision(e, i)} style={{width: '110px'}}>
                    <option value="ADDEDDEPOSIT">ADDEDDEPOSIT</option>
                    {this.props.data.agent_id.length !== 0 ? '' : <option value="TRANSFERRED">TRANSFERRED</option>}
                    <option value="REPORTED">REPORTED</option>
                </select> : <div>{row.status} {row.realize_progress ? <div className="m-loader m-loader--brand" style={{width:'30px',display:'inline-block',verticalAlign:'middle',marginLeft:'5px'}}/> : ''}</div>}</div>
            </div>

        const columns = [{
            dataField: 'id',
            text: 'No.',
            formatter: RowNumber,
            headerAlign: 'center',
            align: 'center',
            style: {width: '3%'}
        },
        {
            dataField: 'bulan_col',
            text: 'Bulan',
            formatter: BulanColumn,
            headerAlign: 'left',
            align: 'left',
            style: {width: '10%'}
        },
        {
            dataField: 'total_trx_event',
            text: 'Jumlah Transaksi',
            headerAlign: 'center',
            align: 'center',
            style: {width: '20%'}
        },
        {
            dataField: 'total_trx_price',
            text: 'Total Nilai Transaksi',
            headerAlign: 'right',
            align: 'right',
            style: {width: '25%'}
        },
        {
            dataField: 'total_commission_received',
            text: 'Total Komisi',
            headerAlign: 'right',
            align: 'right',
            style: {width: '25%'}
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter: StatusColumn,
            headerAlign: 'center',
            align: 'center',
            style: {width: '15%'}
        }]

        const TableTx = (props) =>
            <BootstrapTable 
                keyField='id'
                data={this.state.data_report} striped hover bordered={true} 
                options={this.options} 
                noDataIndication="Tidak ada data" 
                columns={columns}/>


        const RowNumber_Bonus = (cell, row, i) =>
            <div>{i + 1}</div>
        
        const BulanColumn_Bonus = (cell, row) =>
            <div>
                {util.get_month_name(row.report_month)}
            </div>

        const StatusColumn_Bonus = (cell, row, i) =>
            <div>
                <div>{row.status === 'REPORTED' ? <select className="m-input" id={"bonus_status_sel_" + i} value={row.status} onChange={(e) => this.on_select_change_realize_bonus(e, i)} style={{width: '110px'}}>
                    <option value="ADDEDDEPOSIT">ADDEDDEPOSIT</option>
                    {this.props.data.agent_id.length !== 0 ? '' : <option value="TRANSFERRED">TRANSFERRED</option>}
                    <option value="REPORTED">REPORTED</option>
                </select> : <div>{row.status} {row.realize_progress ? <div className="m-loader m-loader--brand" style={{width:'30px',display:'inline-block',verticalAlign:'middle',marginLeft:'5px'}}/> : ''}</div>}</div>
            </div>

        const Columns_Bonus = [{
            dataField: 'id',
            text: 'No.',
            formatter: RowNumber_Bonus,
            headerAlign: 'center',
            align: 'center',
            style: {width: '3%'}
        },
        {
            dataField: 'bulan_col',
            text: 'Bulan',
            formatter: BulanColumn_Bonus,
            headerAlign: 'left',
            align: 'left',
            style: {width: '10%'}
        },
        {
            dataField: 'total_trx_event',
            text: 'Jumlah Transaksi',
            headerAlign: 'center',
            align: 'center',
            style: {width: '20%'}
        },
        {
            dataField: 'total_trx_price',
            text: 'Total Nilai Transaksi',
            headerAlign: 'right',
            align: 'right',
            style: {width: '25%'}
        },
        {
            dataField: 'total_bonus_received',
            text: 'Total Bonus',
            headerAlign: 'right',
            align: 'right',
            style: {width: '25%'}
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter: StatusColumn_Bonus,
            headerAlign: 'center',
            align: 'center',
            style: {width: '15%'}
        }]

        const TableTx_Bonus = (props) =>
            <BootstrapTable 
                keyField='id'
                data={this.state.data_report_bonus} striped hover bordered={true} 
                options={this.options} 
                noDataIndication="Tidak ada data" 
                columns={Columns_Bonus}/>

    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={true}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '700px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            LAPORAN BULANAN {data.agent_name}
	                        </h5>
	                    </div>
	                    <div className="modal-body">
	                        <div className="row">
	                        	<div className="col-lg-12">
			                        <div className="m-portlet__body">
                                        <div className="m-widget4">
                                            <h6>DATA TAHUN&nbsp;&nbsp;
                                                <select className="m-input" id="year_sel" value={this.state.year_sel} onChange={(e) => this.on_select_change(e)} style={{height: '2.2rem', fontSize: '15px', marginLeft: '5px', borderColor: '#ebedf2', color: '#575962', background: '#fff', WebkitAppearance: 'none', padding: '0 10px'}}>
                                                    <option value="2022"> 2022 </option>
                                                    <option value="2021">2021</option>
                                                    <option value="2020">2020</option>
                                                    <option value="2019">2019</option>
                                                    <option value="2018">2018</option>
                                                    <option value="2017">2017</option>
                                                </select>
                                                <button onClick={(e) => this.on_submit_summary(e)} className={this.state.flag_processing ? 'btn m-btn--pill btn-secondary m-btn m-btn--custom  m-btn--bolder m-loader m-loader--primary m-loader--right' : 'btn m-btn--pill btn-secondary m-btn m-btn--custom  m-btn--bolder'} style={{marginLeft: '10px',fontSize: 'small',paddingTop:'7px',paddingBottom:'7px'}}>Submit</button>  
                                            </h6>
                                            <h6 style={{fontWeight: 600,marginBottom: '10px'}}>Data Komisi</h6>
                                            <FormGroup>
                                                <TableTx/>
                                            </FormGroup>
                                            <h6 style={{fontWeight: 600,marginTop: '30px',marginBottom: '10px'}}>Data Bonus</h6>
                                            <FormGroup>
                                                <TableTx_Bonus/>
                                            </FormGroup>
                                        </div>
			                        </div>
			                    </div>

				            </div>
	                    </div>
	                </div>
	            </div>
                {this.state.show_realize ? <ModalRealize data={{agent_name: data.agent_name, report_month: this.state.realize_report_month, report_year: this.state.realize_report_year, new_status: this.state.realize_new_status, type: this.state.realize_type, index: this.state.realize_index, on_submit_realize: this.submit_realize, close : ()=>{
                    self.setState({show_realize: false})
                }}}/> : ''}
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalListCommisionBonus)



// WEBPACK FOOTER //
// ./src/component/form/dialog_list_commision_bonus.js